
hello! this is my pride flag barcode generator; it's based off of the [2002 european union \"barcode\" flag](https://www.oma.com/projects/eu-barcode) that everyone seems to love so much (or love to hate so much).

made with 💙 by [@woobyrubes](https://ruby.gay/)

## help?

making a pride barcode is easy! simply click the flags from the bottom row to add them, and click the ones from the top row to remove them. reordering isn't as simple, but can still be done manually by adding flags in the order you wish.

clicking the \"equal width stripes\" option will make the generator attempt to give each stripe an equal width on the canvas, as opposed to representing each flag as an equal portion of the canvas. it's a minor visual change, but it's there if you want it!

note: because of how the flags are defined in the code, \"equal width stripes\" may sometimes appear *super* wide. there's not a ton i can do about this without a ton of reworks to the rendering system. (sorry, bisexuals/demisexuals/intersex folk!)

### can i use this for my own purposes?

sure! i don't own any of these flag designs, so i wouldn't be able to restrict usage on it - still, if you do use the barcode anywhere, attribution is appreciated (but not necessary)!

<style lang="scss">
    a {
        color: $blue;

        &:visited {
            color: $purple;
        }

        &:active {
            color: $red;
        }
    }

    > * {
        margin: 0.5rem;
    }

    h1, h2, h3 {
        margin-top: 1rem;
    }
</style>
